import { Injectable } from '@angular/core';

export interface Rgb {
  r: number;
  g: number;
  b: number;
}
@Injectable({
  providedIn: 'root',
})
export class ColorService {
  constructor() {}

  hexToRgb(hex: string): Rgb {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  getContrastColorType(color: string): 'dark' | 'light' {
    const rgb = this.hexToRgb(color);
    // Counting the perceptive luminance - human eye favors green color...
    const luminance = this.calculateColorLuminance(rgb) / 255;

    if (luminance > 0.5) {
      return 'dark';
    } else {
      return 'light';
    }
  }

  calculateColorLuminance(color: string | Rgb) {
    const rgb = this._getRgbFromType(color);
    return 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
  }

  private _getRgbFromType(data: string | Rgb): Rgb {
    if (typeof data === 'string') {
      return this.hexToRgb(data);
    } else {
      return data;
    }
  }
}
